import styled from "styled-components";
import { getFontStyles } from "@/redux/cmsConfig/utils";

export const StyledSignUpCheckbox = styled.div(({ theme }) => ({
  alignItems: "flex-start",
  display: "flex",
  width: "100%",

  "a, button": {
    background: "none",
    border: "none",
    color: theme.global.primary_active_color,
    cursor: "pointer",
    textDecoration: "underline",
    ...getFontStyles(theme.text.primary_font, ["font_size", "line_height"], {
      line_height: (value) => (typeof value === "number" ? value : 22),
    }),
  },
  button: {
    paddingLeft: "5px",
  },
}));

export const StyledSubmitButtonRow = styled.div`
  width: 100%;

  button {
    margin: 0 auto;
    width: 100%;
  }
`;
